import {Proposal} from "src/app/entities/proposal";
import {Component, OnInit, Inject} from "@angular/core";
import {
    FormBuilder,
    FormGroup,
    FormControl,
    FormGroupDirective,
    NgForm,
    Validators,
} from "@angular/forms";
import {
    MatDialogRef,
    MAT_DIALOG_DATA,
    MatDialog,
} from "@angular/material/dialog";
import {ProposalService} from "src/app/services/proposal-service";
import {ErrorStateMatcher} from "@angular/material/core";
import {ToastrService} from "ngx-toastr";
import {Subscription} from "rxjs";
import {StorageMap} from "@ngx-pwa/local-storage";
import {ConfirmationDialogComponent} from "../confirmation-dialog/confirmation-dialog.component";
import {Category} from "src/app/entities/category";
import {AuthService} from "src/app/services/auth.service";
import {UtilitiesService} from "src/app/services/utilities.service";
import {OpenSpaceService} from "../../services/open-space.service";
import { DatePipe } from '@angular/common';
import {OpenSpace} from "../../entities/openSpace";
import { VoteService } from "../../services/vote.service";
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: "app-proposal",
    templateUrl: "./proposal.component.html",
    styleUrls: ["./proposal.component.css"],
    providers: [DatePipe]
})
export class ProposalComponent implements OnInit {
    constructor(
        private storage: StorageMap,
        private authService: AuthService,
        private utilitiesService: UtilitiesService,
        private voteService: VoteService,
        private openSpaceService: OpenSpaceService,
        private proposalService: ProposalService,
        private formBuilder: FormBuilder,
        private dialogRef: MatDialogRef<ProposalComponent>,
        private toastr: ToastrService,
        private datePipe: DatePipe,
        @Inject(MAT_DIALOG_DATA) public data: ProposalComponent,
        public confirmationDialog: MatDialog,
        private router: Router,
        private activeRoute: ActivatedRoute,

) { }

    openSpaceId = 0;
    totalVotes = 0;
    canEdit = false;
    canDelete = true;
    openSpace: any;
    content: string;
    myDate = new Date();
    today: string;
    eventdate: string;
    endVotingDate: string;
    matcher = new MyErrorStateMatcher();
    proposal: Proposal = this.data.proposal;
    categories: Category[] = this.data.categories;
    editMode = this.data.editMode;
    createMode = this.data.createMode;
    title = new FormControl({
        value: "",
        disabled: !this.createMode
    }, [Validators.required, this.utilitiesService.noAllWhitespaceValidator]);
    description = new FormControl({
        value: "",
        disabled: !this.createMode
    }, [Validators.required, this.utilitiesService.noAllWhitespaceValidator]);
    category = new FormControl(
        {value: "", disabled: !this.createMode},
        Validators.required
    );
    formGroup = new FormGroup({
        title: this.title,
        description: this.description,
        category: this.category,
    });
    dataSubscription: Subscription;
    proposalNewData: boolean;
    selectedCategory;
    newProposalUserName = "";
    disable: boolean;

    ngOnInit() {
        this.proposalNewData = false;
        this.dataSubscription = this.storage
            .watch("selectedOpenId", {type: "string"})
            .subscribe((openId) => {
                const openIdInt = parseInt(openId, 10);
                if (!isNaN(openIdInt)) {
                    this.openSpaceId = openIdInt;
                }
            });
        if (this.proposal) {
          console.log(this.canEdit, this.canDelete);
            this.openSpaceService.getOpenSpace(this.openSpaceId).subscribe(
                (data) => {
                    this.content = data;
                    this.openSpace = data.OpenSpaces[0];
                    this.totalVotes = this.proposal.totalVotes;
                    this.today = this.datePipe.transform(this.myDate, 'MM/dd/yyyy');
                    this.eventdate = this.datePipe.transform(this.openSpace.eventDate, 'MM/dd/yyyy');
                    this.endVotingDate = this.datePipe.transform(this.openSpace.allowVotingUntilDate, 'MM/dd/yyyy');
                    if (this.totalVotes == 0 || this.eventdate > this.today) {
                         this.canEdit = true;
                    }
                    if (this.endVotingDate > this.today){
                       this.canDelete = true;
                    }
                },
                (error) => {
                    console.error(error);
                }
            );

            this.title.setValue(this.proposal.title);
            this.description.setValue(this.proposal.description);
            this.category.setValue(this.proposal.categoryId);
        }

        if (this.createMode) {
            this.newProposalUserName = this.authService.getUserName();
        }
    }

    onSubmit() {
        this.matcher.submited = true;
        if (this.formGroup.invalid) {
            return;
        }
        this.disable = true;
        if (this.openSpaceId === 0) {
            this.toastr.info(
                "Para crear una propuesta, debe seleccionar un OpenSpace"
            );
            return;
        }
        if (this.editMode && this.proposal) {
            this.transformToProposal();
            this.updateProposal();
        } else {
            this.proposal = new Proposal();
            this.transformToProposal();
            this.createProposal();
        }
    }

    createProposal() {
        this.transformToProposal();
        this.proposalService.addProposal(this.proposal).subscribe(
            (_) => {
                this.toastr.success("Propuesta creada");
                this.proposalNewData = true;
                this.disable = false;
                this.onClose();
            },
            (error) => {
                console.error(error);
                this.disable = false;
            }
        );
    }
  reloadCurrentPage() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

    updateProposal() {
        this.proposalService
            .updateProposal(this.proposal, this.proposal.id)
            .subscribe(
                (data) => {
                    if (data) {
                        this.toastr.success("Propuesta actualizada");
                        this.proposalNewData = true;
                    }
                  this.reloadCurrentPage();
                    this.onClose();
                },

                (error) => {
                    console.error(error);
                }
            );
    }

    edit() {
        if (this.editMode) {
            if (this.formGroup.status === "DISABLED") {
                this.formGroup.enable();
                document.getElementById("title").focus();
            } else {
                this.formGroup.disable();
            }
        }
    }

    deleteConfirmation() {
        this.confirmationDialog
            .open(ConfirmationDialogComponent, {
                data: "¿Desea eliminar la propuesta?",
            })
            .afterClosed()
            .subscribe((confirmed: boolean) => {
                if (confirmed) {
                    this.deleteProposal();
                }
            });
    }

    deleteProposal() {
        this.proposalService.deleteProposal(this.proposal.id).subscribe(
            (data) => {
                if (data) {
                    this.toastr.success("Propuesta eliminada");
                    this.proposalNewData = true;
                }
                this.onClose();
            },
            (error) => {
                console.error(error);
            }
        );
    }

    onClose() {
        this.dialogRef.close({
            event: "close",
            proposalNewData: this.proposalNewData,
        });
    }

    transformToProposal() {
        this.proposal.title = this.formGroup.get("title").value;
        this.proposal.description = this.formGroup.get("description").value;
        this.proposal.categoryId = this.formGroup.get("category").value;
        this.proposal.idOpenSpace = this.openSpaceId;
    }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
    submited = false;

    isErrorState(
        control: FormControl | null,
        form: FormGroupDirective | NgForm | null
    ): boolean {
        const isSubmitted = this.submited;
        return !!(control && control.invalid && isSubmitted);
    }
}
